import { createAction, props } from '@ngrx/store';

export const loadMeasurementItemsMx = createAction('[Measurement Items MX] Load');

export const loadMeasurementItemsMxSuccess = createAction(
  '[Measurement Items MX] Load Success',
  props<{ response: any[] }>(),
);

export const loadMeasurementItemsMxSuccessByKey = createAction(
  '[Measurement Items MX] Load Success By Key',
  props<{ key: string; response: any[] }>(),
);

export const loadMeasurementItemsMxFailure = createAction(
  '[Measurement Items MX] Load Failure',
  props<{ error: any }>(),
);
